import { api } from '../../lib/apiClient';

export type AuditRecord = {
  id: string;
  timestamp: string;
  organization_id?: string;
  user_identity_id?: string;
  wallet_id?: string;
  actor_type: 'portal_user' | 'end_user' | 'api_key' | 'system';
  actor_id?: string;
  event_type: string;
  payload: Record<string, unknown> | null;
  success: boolean;
  error_code?: string;
};

export type AuditPage = {
  items: AuditRecord[];
  total: number;
  limit: number;
  offset: number;
};

export type AuditFilters = {
  event_type?: string;
  success?: boolean;
  limit?: number;
  offset?: number;
};

export async function listAudit(orgId: string, filters: AuditFilters = {}): Promise<AuditPage> {
  const params = new URLSearchParams();
  if (filters.event_type) params.set('event_type', filters.event_type);
  if (filters.success !== undefined) params.set('success', String(filters.success));
  params.set('limit', String(filters.limit ?? 50));
  params.set('offset', String(filters.offset ?? 0));
  const res = await api.get<{ data: AuditPage }>(`/v1/orgs/${orgId}/audit?${params.toString()}`);
  return res.data.data;
}
